import React, { memo } from 'react';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { SubHeading } from 'web-ui-components/lib/typography/headings';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { BulletList } from 'web-ui-components/lib/typography/lists';

const BeginYourApplicationPage = memo(function BeginYourApplicationPage({
  saveApplicationCompleteForm,
  getBusinessData
}) {
  return (
    <Form
      onSubmit={saveApplicationCompleteForm}
      initialValues={getBusinessData}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Content>
            {({
              whatsHappenedListItem1,
              whatsHappenedListItem2,
              yourApplicationTitle,
              eligibilityTitle,
              aboutYourApplicationEligibleContent1,
              aboutYourApplicationEligibleContent2,
              aboutYourApplicationEligibleContent3,
              needToTitle,
              personalDetailsText,
              personalDetailSubItemText,
              businessDetailSubItemText,
              financialDetailSubItemText,
              aboutYourApplicationText
            }) => (
              <div>
                <StandardBody>
                  <PageHeading>{yourApplicationTitle}</PageHeading>
                  <SubHeading>{eligibilityTitle}</SubHeading>
                  <BulletList
                    items={[
                      aboutYourApplicationEligibleContent1,
                      aboutYourApplicationEligibleContent2,
                      aboutYourApplicationEligibleContent3
                    ]}
                  />
                  <SectionHeading>{needToTitle}</SectionHeading>
                  <BulletList
                    items={[
                      personalDetailsText,
                      [personalDetailSubItemText],
                      whatsHappenedListItem1,
                      [businessDetailSubItemText],
                      whatsHappenedListItem2,
                      [financialDetailSubItemText]
                    ]}
                  />
                </StandardBody>
                <Submit />
              </div>
            )}
          </Content>
        </form>
      )}
    />
  );
});
BeginYourApplicationPage.propTypes = {
  saveApplicationCompleteForm: PropTypes.func.isRequired
};

export default BeginYourApplicationPage;
